module.exports = __webpack_public_path__ + "static/media/pic2.89e3289c.jpeg";